/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import * as React from 'react';

import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import { Box, Typography } from '@mui/material';





const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function AlertDialogSlide({
    children,
    open,
    setOpen,
    fullWidth,
    title,
    maxWidth = 'md',
    isHeader,
    onBack
}) {

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            fullWidth={fullWidth}
            maxWidth={maxWidth}

            sx={{
                width: '100%',
                overflowX: "hidden"
            }}
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"

        >
            {isHeader && (
                <Box pt={{ xs: "10px", md: "30px" }} px={{ xs: "10px", md: "30px" }} width="100%" justifyContent="space-between" display="flex" alignItems="flex-end">
                    <Box display="flex" alignItems="center" gap={1}>
                        {
                            onBack && <Box
                                width={38}
                                height={38}
                                onClick={() => onBack()}
                                sx={{
                                    borderRadius: 20,
                                    border: '1px solid #E6E6E6',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    color: '#18181B',
                                    cursor: 'pointer',
                                }}
                            >
                                <svg
                                    width="6"
                                    height="10"
                                    viewBox="0 0 6 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M5.70711 0.292893C6.09763 0.683417 6.09763 1.31658 5.70711 1.70711L2.41421 5L5.70711 8.29289C6.09763 8.68342 6.09763 9.31658 5.70711 9.70711C5.31658 10.0976 4.68342 10.0976 4.29289 9.70711L0.292893 5.70711C-0.0976311 5.31658 -0.0976311 4.68342 0.292893 4.29289L4.29289 0.292893C4.68342 -0.0976311 5.31658 -0.0976311 5.70711 0.292893Z"
                                        fill="#08111F"
                                    />
                                </svg>
                            </Box>

                        }
                        <Typography fontSize={{ xs: 18, md: 22 }} fontWeight={700} >{title}</Typography>
                    </Box>
                    <Box
                        width={38}
                        height={38}
                        onClick={() => handleClose()}
                        sx={{
                            borderRadius: 20,
                            border: '1px solid #E6E6E6',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: "#18181B",
                            cursor: 'pointer'
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="w-5 h-5"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </Box>
                </Box>
            )}

            {children}
        </Dialog>
    );
}
